/**
 * @fileoverview A name sent as pieces, printed: the backend says a plant's
 * name as parts (services/grow/plantNaming), and the ones that tell it from
 * another of the same name (its bed, the day it was added; on Today, its
 * variety or kind) are set in bold here; a note after the name (kind 'note':
 * a job row's " · about ½″") is muted. Nothing is composed: the pieces are
 * printed in the order they came.
 *
 * Where: PlantCard, PlantRow, PlantTile (the title), JobCard (a job's plant
 * rows).
 * API: none.
 *
 * @module NameParts
 */

import React from 'react';
import type { NamePart } from '@/shared/types/plant';

/** The pieces, and how the bold ones are drawn. */
interface NamePartsProps {
  /** The pieces, in order. */
  parts: ReadonlyArray<NamePart>;
  /** The bold pieces' classes; a semibold in the text's own colour unless said. */
  boldClassName?: string;
}

/**
 * The pieces as text, the bold ones in a <strong>, a note muted.
 *
 * @param props - NamePartsProps.
 */
export const NameParts: React.FC<NamePartsProps> = ({ parts, boldClassName = 'font-semibold' }) => (
  <>
    {parts.map((part, index) => (part.bold
      ? <strong key={index} className={boldClassName}>{part.text}</strong>
      : part.kind === 'note'
        ? <span key={index} className="text-muted-foreground">{part.text}</span>
        : <React.Fragment key={index}>{part.text}</React.Fragment>))}
  </>
);
